import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const ThumbsUpIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Thumbs up`} {...props}>
    <Path
      d="M5.75 6.75 8.1 2.4c.2-.38.65-.57 1.06-.44.45.14.71.6.6 1.06l-.55 2.23h3.05c.9 0 1.57.84 1.36 1.72l-.9 3.75a1.75 1.75 0 0 1-1.7 1.35H5.75V6.75ZM2.25 6.75h2v5.32h-2V6.75Z"
      fill="currentColor"
    />
  </Icon>
);
